import { Checkbox, Chip, TableCell, TableRow, Typography } from "@mui/material";
import { FC } from "react";
import { ReceiptsModel } from "../list";
import { isNotPaid } from "../utils/isNotPayed";

interface ReiceptItemProps {
  receipt: any;
  day: {
    day: string;
    receipts: ReceiptsModel[];
  };
  selectedReceipts: { [key: string]: ReceiptsModel[] };
  handleReceiptCheckboxChange: (receipt: ReceiptsModel, day: string) => void;
}
export const ReiceptItem: FC<ReiceptItemProps> = ({
  day,
  receipt,
  handleReceiptCheckboxChange,
  selectedReceipts,
}) => {

  return (
    <TableRow
      sx={{
        "&:nth-of-type(odd)": {
          backgroundColor: "#f2f2f2",
        },
      }}
    >
      <TableCell>
        {isNotPaid(receipt.amount_received, receipt.amount_given) ? (
          <Checkbox
            checked={
              Object.values(selectedReceipts)?.length > 0 &&
              selectedReceipts[day.day]?.includes(receipt)
            }
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              e.stopPropagation();
              handleReceiptCheckboxChange(receipt, day.day);
            }}
          />
        ) : (
          <Typography variant="body2" sx={{ color: "green" }} fontWeight="bold">
            DONE
          </Typography>
        )}
      </TableCell>
      <TableCell>{receipt.client_id}</TableCell>
      <TableCell>
        {receipt.containers.map((c: any) => c.name).join(", ")}
      </TableCell>
      <TableCell>{receipt.receipt_number}</TableCell>
      <TableCell>{receipt.amount_received}</TableCell>
      <TableCell>{receipt.amount_given}</TableCell>
      <TableCell>
        {isNotPaid(receipt.amount_received, receipt.amount_given) ? (
          <Chip label="Not Paid" color="warning" />
        ) : (
          <Chip label="Paid" color="success" />
        )}
      </TableCell>
    </TableRow>
  );
};
